import type { FaireProductEntity } from "../../entity_types/product";

export const p_243v8zx85z: FaireProductEntity = {
  token: "p_243v8zx85z",
  type: "product",
  name: "Eldest Daughter Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/5b5eb94fdfa72e2e3ad1aee91d9f4b03e174dc5512336859b5dd8aa3a345c0a2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fc4f221bd899318d58bbff307c4526986f1422212b441ae9d9b8aaa086f56d2a.jpeg",
    "https://cdn.faire.com/fastly/8a2d2f29a7db5b42b4a94e6d39e6260e778980cd01e65831ac26823651a02500.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/4dbc266ceb5938a0be387989de4f555dc4ddc6db38424d4074b3683187ad5645.jpeg",
    "https://cdn.faire.com/fastly/f64db937aa2325cb43ea9c78faac71f1e6d6fbc1f6d810ebe2708f835a217f32.jpeg"
  ],
  priceDollars: 6.75,
  description: "Soft, stretchy, and a little too responsible for her own good... these socks are made for the one who keeps it all together. ✨ \n\nOur socks are:\n\n• Gender neutral\n• Made in the USA\n• One size fits most\n• Made with a cushioned footbed\n• Packaged with recyclable packaging\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:30:56.086Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
